<template>
  <v-sheet style="height: 100%; width: 100%;">
    <v-sheet style="height: 100%; width: 100%;">
      <l-map ref="map" :zoom="8" :center="center" :class="'wapi_map__map'" @click="click">
        <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
        <l-geo-json ref="refGeoJson" :geojson="geoJson" :options="geoJsonOptions" />
        <l-marker :lat-lng="markerLatLng"></l-marker>
        <l-control :position="'topright'">
          <wapi-panel :title="'Настройки'" :width="400" collapsible>
            <template v-slot:content>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-select
                  v-model="territory"
                  :items="territories"
                  item-text="name"
                  item-value="id"
                  label="Территория"
                  :rules="[rules.required]"
                  :loading="territoriesLoading"
                  :disabled="(territories.length === 0) || territoriesLoading || true"
                  dense
                  outlined
                ></v-select>
                <v-select
                  v-model="parameter"
                  :items="parameters"
                  label="Параметр"
                  :rules="[rules.required]"
                  :loading="parametersLoading"
                  :disabled="(parameters.length === 0) || parametersLoading"
                  dense
                  outlined
                  @change="changeParameter"
                ></v-select>
                <v-select
                  v-model="basetime"
                  :items="basetimes"
                  label="Базовый срок"
                  :rules="[rules.required]"
                  disabled
                  dense
                  outlined
                ></v-select>
                <v-text-field v-model="latitude" label="Широта" type="number"></v-text-field>
                <v-text-field v-model="longitude" label="Долгота" type="number"></v-text-field>
                <interval-scale />
              </v-form>
            </template>
          </wapi-panel>
        </l-control>
      </l-map>
    </v-sheet>
    <div class="valid-times_slider__container" v-if="validTimeList.length">
      <valid-times-slider :items="validTimeList" v-model="validtime" @input="changeValidTime" />
    </div>
  </v-sheet>
</template>

<script>
import WapiContract from "../../models/contract/WapiContract";
import settings from "../../settings.json";
import rules from "../../models/helpers/rules";
import WapiPanel from "../../components/WapiPanel";
import ValidTimesSlider from "./components/ValidTimesSlider";
import IntervalScale from "./components/IntervalScale";
import moment from "moment";
import { getPointInterval } from "../../utils/radarutils";
import ValidTimeModel from "./models/ValidTimeModel";
import { NOWCASTING_INTERVALS } from "../../constants";

export default {
  name: "RadarView",
  title: "Радары",
  components: {
    WapiPanel,
    ValidTimesSlider,
    IntervalScale
  },
  async created() {
    this.territoriesLoading = true;
    this.territories = await this.$store.dispatch("FETCH_RADAR_TERRITORIES");
    this.parameters = this.$store.getters.RADAR_PARAMETERS;

    if (this.territories.length) {
      this.territory = this.territories[0];
    }

    this.territoriesLoading = false;
  },
  data: function() {
    return {
      contractModel: new WapiContract(),
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const fillColor = this.fillColor;
          const val = feature.properties.interval[1];
          layer.setStyle({
            weight: 0.2,
            color: "#3388ff",
            opacity: 1,
            fillColor: fillColor,
            fillOpacity: this.intervalsSettings.find(x => {
              return val >= x.from && val <= x.to;
            }).opacity
          });
        }
      },
      parameters: [],
      parametersLayers: [],
      geoJson: null,
      zoom: settings.zoom,
      center: settings.center,
      valid: true,
      rules: rules,
      territories: [],
      parameter: null,
      territory: null,
      geojsons: [],
      slideItem: null,
      validtimes: [
        "2020-09-09T16:40:00Z",
        "2020-09-09T16:50:00Z",
        "2020-09-09T17:00:00Z"
      ],
      validtime: null,
      basetime: null,
      parametersLoading: false,
      territoriesLoading: false,
      basetimes: [],
      fillColor: "#000080",
      intervals: [],
      markerLatLng: settings.center,
      latitude: settings.center[0],
      longitude: settings.center[1],
      validTimeList: [],
      intervalsSettings: NOWCASTING_INTERVALS
    };
  },
  methods: {
    click(event) {
      const latitude = event.latlng.lat;
      const longitude = event.latlng.lng;
      this.latitude = event.latlng.lat;
      this.longitude = event.latlng.lng;
      this.markerLatLng = [latitude, longitude];
      const validTimeList = this.geojsons.map(x => {
        const model = new ValidTimeModel();
        model.validtime = x.properties.validTime;
        model.interval = getPointInterval(x, longitude, latitude);
        return model;
      });

      this.validTimeList = validTimeList;
    },
    closestDate() {
      const dates = this.validtimes.map(x => moment(x).toDate());
      const max = Math.max(...dates.filter(num => num <= new Date()));
      const maxDate = new Date(max);
      return moment(maxDate)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    },
    changeValidTime(value) {
      const validtime = this.validTimeList[value].validtime;
      this.geoJson = this.geojsons.find(
        x => x.properties.validTime === validtime
      );
    },
    async changeParameter() {
      this.parametersLoading = true;
      await this.result();
      this.parametersLoading = false;
    },
    async result() {
      const request = {
        territory: this.territory,
        parameter: this.parameter
      };
      this.basetime = await this.$store.dispatch(
        "FETCH_RADAR_LAST_BASETIME",
        request
      );
      this.basetimes = [this.basetime];
      const request2 = {
        territory: this.territory,
        parameter: this.parameter,
        basetime: this.basetime
      };

      this.validtimes = await this.$store.dispatch(
        "FETCH_RADAR_VALIDTIMES",
        request2
      );

      const request3 = {
        territory: this.territory,
        parameter: this.parameter,
        validtimes: this.validtimes
      };

      this.geojsons = await this.$store.dispatch(
        "FETCH_RADAR_GEOJSON",
        request3
      );
      this.geojson = this.geojsons[0];

      const validTimeList = this.geojsons.map(x => {
        const model = new ValidTimeModel();
        model.validtime = x.properties.validTime;
        model.interval = getPointInterval(x, this.longitude, this.latitude);
        return model;
      });

      this.validTimeList = validTimeList;

      const closest = this.closestDate();
      const index = this.validTimeList.findIndex(x => x.validtime === closest);
      this.validtime = index;
      this.geoJson = this.geojsons.find(
        x => x.properties.validTime === closest
      );
    }
  },
  computed: {
    styleFunction() {
      const fillColor = this.fillColor;
      return () => {
        return {
          weight: 0.2,
          color: "#ECEFF1",
          opacity: 1,
          fillColor: fillColor,
          fillOpacity: 1
        };
      };
    }
  }
};
</script>

<style>
.valid-times_slider__container {
  position: absolute;
  bottom: 0;
  z-index: 1000;
  height: 220px;
  width: 100%;
}
</style>